// import types
import type { GridTreeNodeWithRender } from '@mui/x-data-grid-pro';
import type { Month } from 'date-fns';

export const toMonth = (n: number): Month =>
  Math.max(0, Math.min(11, n)) as Month;

export const isGroupOrLeafNode = (
  node: GridTreeNodeWithRender
): node is GridTreeNodeWithRender & { groupingKey: any; depth: number } => {
  return node.type === 'group' || node.type === 'leaf';
};

export const getChildrenExpanded = (node: GridTreeNodeWithRender): boolean => {
  if (
    'childrenExpanded' in node &&
    typeof node.childrenExpanded === 'boolean'
  ) {
    return node.childrenExpanded;
  }
  return false;
};

export const isNavigationKey = (key: string) =>
  key === 'Home' ||
  key === 'End' ||
  key.indexOf('Arrow') === 0 ||
  key.indexOf('Page') === 0 ||
  key === ' ';
